<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Quản lý tác vụ thanh tra chấm BTVN</h3>
      </div>
      <div class="card-title">
        <action-bar @export="exportNow" @classify="openTeacherClassification" @create="openCreate" />
      </div>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <div class="row align-items-end">
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Bài tập về nhà</label>
            <el-input class="w-100" v-model="query.id" placeholder="Nhập mã bài tập"></el-input>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Giảng viên chấm</label>
            <el-input class="w-100" v-model="query.teacher_keyword"
              placeholder="Nhập họ tên, mã, số điện thoại"></el-input>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Học viên làm bài</label>
            <el-input class="w-100" v-model="query.student_keyword"
              placeholder="Nhập họ tên, mã, số điện thoại"></el-input>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Hình thức bài tập</label>
            <el-select class="w-100" v-model="query.exercise_format" clearable placeholder="Chọn hình thức bài tập">
              <el-option label="Speaking" value="1"></el-option>
              <el-option label="Writing" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Phân loại thanh tra</label>
            <el-select class="w-100" v-model="query.types" multiple filterable collapse-tags
              placeholder="Chọn phân loại thanh tra">
              <el-option label="Định kỳ" value="1"></el-option>
              <el-option label="Phúc khảo" value="2"></el-option>
              <el-option label="Làm lại BTVN fail" value="3"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Người phụ trách</label>
            <el-select class="w-100" v-model="query.person_in_charges" multiple filterable collapse-tags
              placeholder="Chọn người phụ trách">
              <el-option label="Trống" value=""></el-option>
              <el-option v-for="item in assignees" :key="item.id" :label="`${item.id + 100000} - ${item.name}`"
                :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row mt-2 align-items-end">
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Kết quả thanh tra</label>
            <el-select class="w-100" v-model="query.result" clearable placeholder="Chọn kết quả thanh tra">
              <el-option label="Đạt" value="1"></el-option>
              <el-option label="Không đạt" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Trạng thái</label>
            <el-select class="w-100" v-model="query.status" multiple filterable collapse-tags
              placeholder="Chọn trạng thái">
              <el-option label="Cần thanh tra" value="0"></el-option>
              <el-option label="Cần chấm lại" value="1"></el-option>
              <el-option label="Hoàn thành" value="2"></el-option>
            </el-select>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Thời gian tạo bản ghi</label>
            <date-picker class="w-100" v-model="query.created_ats" type="date" format="DD-MM-YYYY"
              value-type="YYYY-MM-DD" range placeholder="Chọn khoảng thời gian"
              @change="handleDateChange"></date-picker>
          </div>
          <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
            <label>Trung tâm</label>
            <el-select class="w-100" v-model="query.center_ids" multiple filterable collapse-tags
              placeholder="Chọn trung tâm" @change="changeCenter">
              <el-option v-for="item in centers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <!-- removed manual search; auto fetch with debounce -->
        <div class="example-preview table-responsive overflow-auto mt-8 position-relative">

          <!-- Bulk action bar -->
          <div v-if="selectedItems.length > 0" class="d-flex align-items-center m-3">
            <span class="mr-3">Đã chọn ({{ selectedItems.length }})</span>
            <button class="btn btn-primary mr-2" @click="openAssignDialog"><i class="fa fa-random mr-1"></i> Điều phối
              công việc</button>
            <button class="btn btn-light" @click="() => { selectedItems = []; selectAll = false; }">Hủy</button>
          </div>
          <table class="table table-hover table-bordered table-vertical-center b-table"
            style="text-align: center; table-layout: fixed;">
            <thead>
              <tr>
                <th style="width: 50px;">
                  <el-checkbox v-model="selectAll" @change="handleSelectAll"></el-checkbox>
                </th>
                <th style="width: 80px;">Mã bài tập</th>
                <th style="width: 200px;">Bài tập về nhà</th>
                <th style="width: 80px;">Hình thức</th>
                <th style="width: 160px;">Học viên làm bài</th>
                <th style="width: 160px;">Giảng viên chấm</th>
                <th style="width: 120px;">Phân loại</th>
                <th style="width: 140px;">Người phụ trách</th>
                <th style="width: 110px;">Trạng thái</th>
                <th style="width: 110px;">Kết quả</th>
                <th style="width: 100px;">Thời gian tạo</th>
                <th style="width: 100px;">Hành động</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr role="row" class="b-table-busy-slot">
                <td colspan="12" role="cell" class="">
                  <div class="text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in inspectionList" :key="item.id">
                <td>
                  <el-checkbox class="ml-2" v-model="selectedItems" :label="item.id"
                    :disabled="item.status == 2"><span></span></el-checkbox>
                </td>
                <td>{{ item.id }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ item.homework }}</td>
                <td>{{ item.exercise_format }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ `${item.user_id + 100000} -
                  ${item.student_name}` }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">{{ `${item.teacher_id + 100000} -
                  ${item.teacher_name}` }}</td>
                <td>{{ getInspectionTypeText(item.type) }}</td>
                <td style="word-wrap: break-word; overflow-wrap: break-word;">
                  <span>{{ item?.person_charge_name }}</span>
                </td>
                <td><span :class="getStatusBadge(item.status)">{{ getStatusText(item.status) }}</span></td>
                <td>{{ getResultText(item.result) }}</td>
                <td>{{ item.created_at | formatDate }}</td>
                <td>
                  <el-tooltip v-if="item.type == 2" content="Lý do phúc khảo">
                    <button class="btn btn-icon btn-xs btn-outline-warning mr-2" @click="openAppealReasonModal(item)">
                      <i class="fa fa-file-alt"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip :content="item.status == 0 ? 'Thanh tra' : 'Xem lại bài tập thanh tra'">
                    <button class="btn btn-icon btn-xs btn-outline-info mr-2" @click="inspectOrView(item)">
                      <i class="fa fa-eye"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip v-if="item.status == 0" content="Xóa">
                    <button class="btn btn-icon btn-xs btn-outline-danger" @click="removeItem(item)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </el-tooltip>
                </td>
              </tr>
              <tr v-if="inspectionList.length === 0 && !loading">
                <td colspan="12" class="event-title no-data">Không có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-3">
          <div class="text-right">
            Tổng số giảng viên: <b class="text-primary">{{ total_teachers }}</b>
            <span class="mx-3">|</span>
            Tổng số bản ghi: <b class="text-primary">{{ total }}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1" :click-handler="clickCallback"
        :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
        :pageLinkClass="'page-link'" :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'"
        :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
      </paginate>
    </div>

    <!-- Delete Confirm Dialog -->
    <delete-confirm-dialog v-if="confirmVisible" :visible.sync="confirmVisible" :loading="deleting"
      @confirm="doDelete" />

    <!-- Assign Modal -->
    <assign-dialog v-if="assignDialogVisible" :visible.sync="assignDialogVisible" :qc-assignees="qcAssignees"
      :selected-ids="selectedItems" @confirm="onAssignConfirm" />

    <!-- Create Modal -->
    <inspection-create-modal v-if="createDialogVisible" :visible.sync="createDialogVisible" @created="handleCreated" />

    <!-- Teacher Category Modal -->
    <teacher-category-modal v-if="teacherCategoryDialog" :visible.sync="teacherCategoryDialog"
      @open-import="openTeacherImport" />
    <teacher-category-import v-if="teacherImportDialog" :visible.sync="teacherImportDialog" @done="onTeacherImportDone"
      @close="exitImport" />

    <!-- Appeal Reason Modal -->
    <appeal-reason-modal v-if="appealReasonModalVisible" :visible.sync="appealReasonModalVisible"
      :appeal-data="currentAppealData" :homework-id="currentHomeworkId" />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import { GET_CENTERS } from "../../../core/services/store/center/centers.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { INSPECTION_LIST, INSPECTION_ASSIGN, INSPECTION_DELETE, INSPECTION_EXPORT_ALL, INSPECTION_GET_PERSON_IN_CHARGE } from '@/core/services/store/inspection/inspection.module';
import { exportExcel, HEADER_ROW_EXPORT_INSPECTION_HOMEWORK } from "../../../core/filters";
import {
  InspectionCreateModal, TeacherCategoryModal, TeacherCategoryImport, AssignDialog, ActionBar, DeleteConfirmDialog, AppealReasonModal,
} from './components/inspection-management';
const _ = require('lodash');

export default {
  components: {
    DatePicker,
    InspectionCreateModal,
    TeacherCategoryModal,
    TeacherCategoryImport,
    AssignDialog,
    ActionBar,
    DeleteConfirmDialog,
    AppealReasonModal,
  },

  name: "InspectionHomeworkManagement",
  data() {
    return {
      query: {
        center_ids: [],
        id: '',
        teacher_keyword: '',
        student_keyword: '',
        exercise_format: '',
        types: [],
        person_in_charges: [],
        result: '',
        status: [],
        created_ats: []
      },
      inspectionList: [],
      centers: [],
      center_ids: [],
      assignees: [],
      is_disable_search: false,
      last_page: 1,
      page: 1,
      total: 0,
      total_teachers: 0,
      is_disable_export: false,
      is_dialog_option: false,
      type_export: 1,
      loading: true,
      selectAll: false,
      selectedItems: [],
      assignDialogVisible: false,
      qcAssignees: [],
      createDialogVisible: false,
      teacherCategoryDialog: false,
      teacherImportDialog: false,
      confirmVisible: false,
      deleting: false,
      __initializingFromRoute: false,
      appealReasonModalVisible: false,
      currentAppealData: null,
      currentHomeworkId: null,
    };
  },

  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản trị chất lượng", route: "" },
      { title: "Quản lý tác vụ thanh tra chấm BTVN", route: "" }
    ]);
    await this.getCenters();
    await this.getPersonInCharge();
    this.initQueryFromRoute();
    this.callApiGetList();
  },

  methods: {
    exitImport() {
      this.teacherImportDialog = false;
      this.teacherCategoryDialog = true;
    },
    openTeacherClassification() {
      this.teacherCategoryDialog = true;
    },
    openTeacherImport() {
      this.teacherImportDialog = true;
    },
    onTeacherImportDone() {
      this.teacherImportDialog = false;
      this.teacherCategoryDialog = true;
    },
    openCreate() {
      this.$nextTick(() => { this.createDialogVisible = true; });
    },
    changeCenter() { },
    normalizeArray(val) {
      if (val === undefined || val === null) return [];
      if (Array.isArray(val)) return val.filter(v => v !== undefined && v !== null && v !== '');
      if (val === '') return [];
      return [val];
    },
    initQueryFromRoute() {
      const q = this.$route.query || {};
      this.__initializingFromRoute = true;
      this.query = {
        center_ids: this.normalizeArray(q.center_ids),
        id: q.id || '',
        teacher_keyword: q.teacher_keyword || '',
        student_keyword: q.student_keyword || '',
        exercise_format: q.exercise_format || '',
        types: this.normalizeArray(q.types),
        person_in_charges: this.normalizeArray(q.person_in_charges),
        result: q.result || '',
        status: this.normalizeArray(q.status),
        created_ats: Array.isArray(q.created_ats) ? q.created_ats : (q.created_ats ? [q.created_ats] : []),
      };
      this.page = q.page ? Number(q.page) : 1;
      this.$nextTick(() => { this.__initializingFromRoute = false; });
    },
    handleDateChange(value) {
      // Fix for date-picker clearing issue: when cleared, it sends [null, null]
      // We need to convert this to an empty array or null to avoid sending null parameters
      if (Array.isArray(value) && value.length === 2 && value[0] === null && value[1] === null) {
        this.query.created_ats = [];
      } else {
        this.query.created_ats = value;
      }
    },
    // Debounced search similar to your pattern
    search: _.debounce(function () {
      // Keep URL query in sync then fetch
      this.page = 1;
      this.pushParamsUrl();
      this.callApiGetList();
    }, 200),
    async exportNow() {
      this.is_disable_export = true;
      let data_export;
      try {
        await this.$store.dispatch(INSPECTION_EXPORT_ALL, {
          ...this.query,
          is_all: true
        }).then((res) => {
          data_export = res.data;
        });
        exportExcel(HEADER_ROW_EXPORT_INSPECTION_HOMEWORK, data_export, "Danh sách bài tập thanh tra.xlsx", false);
        this.$message.success('Xuất dữ liệu thành công');
      } catch (error) {
        console.error('Export error:', error);
        this.$message.error('Không thể xuất được dữ liệu');
      } finally {
        this.is_disable_export = false;
      }
    },
    handleCreated() {
      this.createDialogVisible = false;
      this.page = 1;
      this.$message.success('Tạo danh sách thanh tra thành công');
      this.callApiGetList();
    },

    openAssignDialog() {
      if (this.selectedItems.length === 0) return;
      this.$nextTick(() => { this.assignDialogVisible = true; });
    },
    async onAssignConfirm(data) {
      try {
        await this.$store.dispatch(INSPECTION_ASSIGN, {
          person_in_charge: data.assignee_id,
          inspectionIds: this.selectedItems
        });

        this.assignDialogVisible = false;
        this.$message.success({ title: 'Điều phối công việc', message: 'Thành công' });
        this.selectedItems = [];
        this.selectAll = false;
        this.callApiGetList();
      } catch (error) {
        console.error('Assign error:', error);
        this.$message.error('Có lỗi xảy ra khi gán tác vụ');
      }
    },
    closeDialog() {
      this.is_dialog_option = false;
      this.is_disable_export = false;
      this.type_export = 1;
    },
    handleSelectAll(val) {
      if (val) {
        this.selectedItems = this.inspectionList.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    clickCallback(obj) {
      this.page = obj;
      this.$router.push({
        name: 'inspection-homework-management',
        query: {
          page: this.page,
          ...this.query
        }
      });
      this.callApiGetList();
    },
    pushParamsUrl() {
      this.$router.push({
        name: 'inspection-homework-management',
        query: {
          page: this.page,
          ...this.query
        }
      });
    },
    searchData() {
      this.page = 1;
      this.is_disable_search = true;
      this.pushParamsUrl();
      this.callApiGetList();
    },
    async callApiGetList() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(INSPECTION_LIST, {
          ...this.query,
          page: this.page,
          per_page: 20
        });
        this.loading = false;
        this.inspectionList = response.data.original.data;

        this.last_page = response.data.original.pagination.last_page;
        this.total = response.data.original.pagination.total;
        this.total_teachers = response.totalTeacher ?? 0;
        this.is_disable_search = false;
      } catch (error) {
        this.loading = false;
        this.is_disable_search = false;
      }
    },

    

    // API methods
    getCenters() {
      return this.$store.dispatch(GET_CENTERS, { limit: 10000, status: 1, is_edutalk: '1' }).then((res) => {
        if (!res.error) {
          for (let dataKey in res.data.data) {
            this.center_ids.push(res.data.data[dataKey].id);
            this.centers.push({
              id: res.data.data[dataKey].id,
              name: res.data.data[dataKey].name,
            });
          }
        }
      });
    },

    // API methods
    async getPersonInCharge() {
      try {
        const response = await this.$store.dispatch(INSPECTION_GET_PERSON_IN_CHARGE);
        this.qcAssignees = response.data || [];
        // Sử dụng cùng dữ liệu cho filter dropdown
        this.assignees = response.data || [];
      } catch (error) {
        console.error('Error getting person in charge:', error);
        this.$message.error('Không thể tải danh sách người phụ trách');
      }
    },


    getStatusText(status) {
      const statusTexts = {
        0: 'Cần thanh tra',
        1: 'Cần chấm lại',
        2: 'Hoàn thành'
      };
      return statusTexts[status] || 'Không xác định';
    },
    getStatusBadge(status) {
      const statusClasses = {
        0: 'badge badge-warning',
        1: 'badge badge-info',
        2: 'badge badge-success'
      };
      return statusClasses[status] || 'badge badge-secondary';
    },
    getInspectionTypeText(type) {
      const map = {
        1: 'Định kỳ',
        2: 'Phúc khảo',
        3: 'Làm lại BTVN Fail',
      };
      return map[type] || '';
    },
    getResultText(result) {
      const map = { 1: 'Đạt', 2: 'Không đạt' };
      return result ? map[result] : '';
    },
    inspectOrView(item) {
      const query = {};
      if (item.status !== 0) {
        query.mode = 'show';
      }
      const routeData = this.$router.resolve({
        name: 'inspection-task-detail',
        params: { id: item.id },
        query
      });

      window.open(routeData.href, '_blank');
    },
    openAppealReasonModal(item) {
      const appealData = {
        images: Array.isArray(item.medias)
          ? item.medias.map((url, index) => ({
              id: `image_${item.id}_${index}`,
              url,
              thumbnail: url,
              description: `Hình ảnh mô tả lỗi ${index + 1}`,
              alt: `Hình ảnh mô tả lỗi ${index + 1}`
            }))
          : [],
        reason: item.reason || 'Không có thông tin lý do phúc khảo',
        id: item.id,
        submitted_at: item.created_at || null,
        status: item.status || null,
        submitted_by: item.submitted_by || null,
        submitted_by_id: item.submitted_by_id || null,
        category: item.category || null,
        priority: item.priority || null
      };

      this.currentAppealData = appealData;
      this.currentHomeworkId = item.id;
      this.appealReasonModalVisible = true;
    },


    removeItem(item) {
      this.itemToDelete = item;
      this.confirmVisible = true;
    },
    async doDelete() {
      this.deleting = true;
      await this.$store.dispatch(INSPECTION_DELETE, { id: this.itemToDelete.id }).then((response) => {
        this.inspectionList = this.inspectionList.filter(x => x.id !== this.itemToDelete.id);
        this.total -= 1;
        this.$message.success({ message: 'Thành công', title: 'Xóa tác vụ' });
      }).catch((error) => {
        this.$message.error(error.data.message ? error.data.message : 'Có lỗi xảy ra khi xóa tác vụ');
      }).finally(() => {
        this.callApiGetList();
        this.deleting = false;
        this.itemToDelete = null;
        this.confirmVisible = false;
      });
    }
  },

  watch: {
    query: {
      handler() {
        if (this.__initializingFromRoute) return;
        this.search();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 5;
}
</style>
